import type { VehicleLockStatusDto } from "@/lib/api";
import type { LockStatusReturn } from "@/types/telematics.types";

export function mapVehicleLockStatusDtoToLockStatus(
	dto: VehicleLockStatusDto
): LockStatusReturn {
	return {
		lockStatus: dto.centralLockStatus,
		immobilizerStatus: dto.immobilizerStatus,
	};
}
